import React, { useState } from 'react';
import { Select } from 'antd';

function TypeableSelect({ list, onSelect, selected, labelField, selectedValueField, valueField, required = false, placeholder = "Select", isObject = true, height, fontSize = '13px', disabled = false, autoOpen = false }) {
    const [searchText, setSearchText] = useState('');

    const options = (list ?? []).map(item => ({
        label: isObject ? (item?.[labelField] ?? '') : (item ?? ''),
        value: isObject ? item?.[valueField] : item,
        item,
    }));

    const currentValue = isObject
        ? (selected?.[(selectedValueField ?? valueField)] ?? undefined)
        : (selected ?? undefined);

    return (
        <Select
            showSearch
            allowClear
            autoFocus={autoOpen}
            disabled={disabled}
            placeholder={placeholder}
            value={currentValue !== undefined && currentValue !== null ? currentValue : undefined}
            options={options}
            size="middle"
            style={{ width: '100%', fontSize, height: height ?? '40px', placeholder: { fontSize, style: { fontSize } } }}
            styles={{ popup: { root: { fontSize } } }}
            filterOption={(input, option) =>
                (String(option?.label ?? '')).toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(a, b) => {
                if (!searchText) return 0;
                const lower = searchText.toLowerCase();
                const idxA = (String(a.label ?? '')).toLowerCase().indexOf(lower);
                const idxB = (String(b.label ?? '')).toLowerCase().indexOf(lower);
                return idxA - idxB;
            }}
            onSearch={setSearchText}
            onChange={(val, option) => {
                setSearchText('');
                onSelect(val !== undefined && val !== null ? option?.item : null);
            }}
        />
    );
}

export default TypeableSelect;
